module.exports = __webpack_public_path__ + "img/circlePsb.ba488780.svg";